export default __webpack_public_path__ + "static/media/bird-head-new-crop.64f671da.jpg";